import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { saveAs } from 'file-saver';
import AppShell from '../../components/layout/AppShell';
import { PageHeader, Card, CardHeader, CardBody, Button, Alert } from '../../components/ui';
import WorkbookUpload, { ImportSummary } from './WorkbookUpload';
import { analyzeMaintenance } from './analysis';
import { createGraphs, createGraphZip } from './charts';

export default function MaintenanceAnalysisPage() {
  const [data, setData] = useState(null);
  const [graphs, setGraphs] = useState([]);
  const [busy, setBusy] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    const urls = [];
    setGraphs([]); setError('');
    if (!data) { setBusy(false); return undefined; }
    setBusy(true);
    createGraphs(analyzeMaintenance(data)).then((items) => {
      if (cancelled) return;
      setGraphs(items.map((g) => { const url = URL.createObjectURL(g.blob); urls.push(url); return { ...g, url }; }));
    }).catch((e) => { if (!cancelled) setError(e.message); }).finally(() => { if (!cancelled) setBusy(false); });
    return () => { cancelled = true; urls.forEach((url) => URL.revokeObjectURL(url)); };
  }, [data]);
  const downloadAll = async () => {
    setExporting(true); setError('');
    try { const zip = await createGraphZip(graphs, data.month); saveAs(zip.blob, zip.filename); }
    catch (e) { setError(e.message || 'ZIP export failed.'); }
    finally { setExporting(false); }
  };
  return <>
    <PageHeader title="Maintenance Analysis" subtitle="Monthly CM and PPM analysis" backTo="/" actions={<Button disabled={graphs.length !== 8 || exporting || busy} onClick={downloadAll}>{exporting ? 'Preparing ZIP…' : 'Download All Graphs (ZIP)'}</Button>} />
    <AppShell>
      <div className="space-y-6">
        <Card><CardHeader title="Monthly maintenance workbook" /><CardBody><WorkbookUpload onLoaded={setData} onClear={() => setData(null)} disabled={busy || exporting} /></CardBody></Card>
        <ImportSummary data={data} />
        {data && <Button variant="secondary" onClick={() => navigate('/system-report', { state: { maintenanceWorkbook: data } })}>Use this workbook in System Report</Button>}
        {busy && <p role="status">Generating eight high-resolution graphs…</p>}
        {error && <Alert variant="error" title="Graph export failed">{error}</Alert>}
        <div className="grid gap-6 lg:grid-cols-2">{graphs.map((g) => <Card key={g.id}>
          <CardHeader title={g.title} /><CardBody>
            <a href={g.url} target="_blank" rel="noreferrer" aria-label={`Open full-size preview: ${g.title}`}><img src={g.url} alt={g.title} className="h-auto w-full rounded-md" /></a>
            <Button variant="secondary" className="mt-3" onClick={() => saveAs(g.blob, g.filename)}>Download PNG</Button>
          </CardBody>
        </Card>)}</div>
      </div>
    </AppShell>
  </>;
}
